import { useState } from "react";
import dayjs from 'dayjs';
import DC from "../../common/DataConnector";
import HelperProducts from "../../common/HelperProducts";
import { dicNames, i18n } from '../../lang/i18n';
import OrderModel from "../../models/OrderModel";
import PayWithCardRedsys from "../CartAndPayment/PayWithCardRedsys";
import PayWithGoogle from "../CartAndPayment/PayWithGoogle";
import { useNavigate } from "react-router-dom";
import { CustomerOrderStatus, PaymentStatus } from "../../common/Enums";
import { actAlertShow, actLoading, actLoadingEnd } from "../../store/Actions";
import { useAppDispatch, useAppSelector } from "../../store/hooks";

interface Props {
    order: OrderModel,
    productExtras: any,
    showDetails: boolean,
    onClose:()=>void
}

export default function UserOrderRow(props: Props) {
    const dispatch = useAppDispatch()
    const appConf = useAppSelector((state) => state.appConf)
    const navigate = useNavigate();
    const [showDetails, setShowDetails] = useState(props.showDetails)

    function onDetailsClick(e: any) {
        e.preventDefault();
        setShowDetails(!showDetails)
    }
    function stateIcon(state: number) {
        if (props.order.orderStatus.id >= state)
            return 'far fa-check-square';
        else
            return 'far fa-square';
    }
    function stateColor(state: number) {
        if (props.order.orderStatus.id >= state)
            return appConf.colors.priceColor;
        else
            return undefined;
    }

    async function onOrderCancel() {
        actLoading(dispatch)
        let content = await DC.Delete('/customer/orders/'+props.order.orderId);
        if (content.wasOk) {
            props.onClose();
        } else {
            actAlertShow(dispatch, 'warning', i18n.Errors.ErrorSavingData);
        }
        actLoadingEnd(dispatch)
    }

    async function onGetRedsysData() {
        actLoading(dispatch)
        let content = await DC.PostData('/customer/orders/'+props.order.orderId+'/pay', {});
        if (content.wasOk) {
            actLoadingEnd(dispatch)
            props.onClose();
            return content.data;
        } else {
            actAlertShow(dispatch, 'warning', i18n.Errors.ErrorRetrievingInformation);
        }
        actLoadingEnd(dispatch)
    }

    async function onGooglePayOk(paymentRequest:any){
        actLoading(dispatch)
        let content = await DC.PostData('/customer/orders/'+props.order.orderId+'/gpay', {paymentInfo:JSON.stringify(paymentRequest)});
        if (content.wasOk) {
            actLoadingEnd(dispatch)
            navigate('/pok')
            props.onClose();
            return content.data;
        } else {
            actAlertShow(dispatch, 'warning', i18n.Errors.ErrorSavingData);
        }
        actLoadingEnd(dispatch)
    }

    function renderStatus() {
        return <div className="col-12 order-status">
            <div className="row-check">
                <span style={{ background: stateColor(CustomerOrderStatus.Pending), borderColor: stateColor(CustomerOrderStatus.Pending)}}><i className={stateIcon(CustomerOrderStatus.Pending)} style={{ color: stateColor(CustomerOrderStatus.Pending) }} /></span>
                <div style={{ flex: 1, paddingLeft: 10 }}>{dicNames[CustomerOrderStatus.Pending]}</div>
            </div>
            <div className="row-line" style={{ color: stateColor(CustomerOrderStatus.Pending) }}>
                <div>|</div>
                <div style={{ flex: 1 }}></div>
            </div>
            <div className="row-check">
                <span style={{ background: stateColor(CustomerOrderStatus.InQueue), borderColor: stateColor(CustomerOrderStatus.InQueue)}}><i className={stateIcon(CustomerOrderStatus.InQueue)} style={{ color: stateColor(CustomerOrderStatus.InQueue) }} /></span>
                <div style={{ flex: 1, paddingLeft: 10 }}>{dicNames[CustomerOrderStatus.InQueue]}</div>
            </div>
            <div className="row-line" style={{ color: stateColor(CustomerOrderStatus.InQueue) }}>
                <div>|</div>
                <div style={{ flex: 1 }}></div>
            </div>
            <div className="row-check">
                <span style={{ background: stateColor(CustomerOrderStatus.InPreparation), borderColor: stateColor(CustomerOrderStatus.InPreparation)}}><i className={stateIcon(CustomerOrderStatus.InPreparation)} style={{ color: stateColor(CustomerOrderStatus.InPreparation) }} /></span>
                <div style={{ flex: 1, paddingLeft: 10 }}>{dicNames[CustomerOrderStatus.InPreparation]}</div>
            </div>
            <div className="row-line" style={{ color: stateColor(CustomerOrderStatus.InPreparation) }}>
                <div>|</div>
                <div style={{ flex: 1 }}></div>
            </div>
            <div className="row-check">
                <span style={{ background: stateColor(CustomerOrderStatus.Prepared), borderColor: stateColor(CustomerOrderStatus.Prepared)}}><i className={stateIcon(CustomerOrderStatus.Prepared)} style={{ color: stateColor(CustomerOrderStatus.Prepared) }} /></span>
                <div style={{ flex: 1, paddingLeft: 10 }}>{dicNames[CustomerOrderStatus.Prepared]}</div>
            </div>
        </div>
    }

    function renderActions(){
        if(props.order.paymentStatus.id !== PaymentStatus.PayOk)
            return <>
                <div className="mb-3 badge badge-pill badge-danger">{item.paymentStatus.name}</div>
                <div className="mb-2">
                    <PayWithGoogle onPaymentOk={onGooglePayOk} totalPrice={props.order.totalPrice}/>
                </div>
                <div>
                    <PayWithCardRedsys onGetRedsysData={onGetRedsysData} totalPrice={props.order.totalPrice} title={i18n.TabCart.PayWithCard}/>
                <div>
                </div>
                    <button className="btn btn-outline-dark mt-3 btn-pay btn-pay-cancel" onClick={onOrderCancel}>
                        {i18n.Orders.CancelOrder}
                    </button>
                </div>
            </>
        return <div className="mb-2 badge badge-pill badge-success">{item.paymentStatus.name}</div>
    }

    let item = props.order;
    if (showDetails) {
        let products = item.products;
        return (<li className="list-group-item container mb-2" onClick={onDetailsClick}>
            <div className="row">
                <div className="col-12">
                    <span className="float-right"><i className="fa fa fa-angle-up"></i></span>
                    <h3>Nº {item.orderNumber} ({dayjs(item.orderDate).format("HH:mm")}) {dicNames[props.order.orderStatus.id]}</h3>
                </div>
                <div className="col-md-6">
                    {renderStatus()}
                </div>
                <div className="col-md-6 text-right">
                    {renderActions()}
                </div>
                <table className="table mt-2">
                    <thead>
                        <tr>
                            <th>{i18n._Labels.Product}</th>
                            <th className="text-right">€</th>
                        </tr>
                    </thead>
                    <tbody>
                        {products.map((item: any, index: number) => (
                            <tr key={index}>
                                <td>{HelperProducts.ProductDescription(props.productExtras, item)}</td>
                                <td className="text-right">{ item.ritmitosUsed > 0?item.ritmitosUsed+ '⚡':item.quantity +' x ' + item.price.toFixed(2)+'€'}</td>
                            </tr>
                        ))}
                        <tr>
                            <td colSpan={2} className="text-right">{i18n.TabCart.ListTotal}: {item.totalPrice.toFixed(2)} €</td>
                        </tr>
                        <tr>
                            <td colSpan={2} className="text-right">{i18n.UserOrder.RitmitosUsed}: {item.ritmitosUsed} ⚡</td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </li>
        )
    }
    return (
        <li className="list-group-item container mb-2" onClick={onDetailsClick}>
            <div className="row">
                <div className="col-12">
                    <span className="float-right"><i className="fa fa-angle-down"></i></span>
                    <h3>Nº {item.orderNumber} ({dayjs(item.orderDate).format("HH:mm")}) {props.order.orderStatus.name}</h3>
                </div>
                <div className="col-md-6">
                    {renderStatus()}
                </div>
                <div className="col-md-6 text-right">
                    {renderActions()}
                </div>
            </div>
        </li>
    );
}